<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3>{{ label.get("manage_team") }}</h3>
      </div>
      <div class="white-card members-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{ label.get("members") }}</label>
          </div>
          <button class="add-new-btn" type="button" @click="inviteMember">
            <i class="atto atto-add-more" />
            {{ label.get("invite_new_members") }}
          </button>
        </div>
        <div class="list-container">
          <div class="outer">
            <div class="inner">
              <table class="list-container">
                <thead class="table-heading">
                  <tr>
                    <th>
                      <span class="heading-label name">
                        {{ label.get("name") }}
                        <!--<i class="arrow-sort" />-->
                      </span>
                    </th>
                    <td class="role-wrap-holder">
                      <span class="heading-label rl">{{
                        label.get("role")
                      }}</span>
                    </td>
                    <td class="dep-wrap-holder">
                      <span class="heading-label dep">
                        {{ label.get("department") }}
                        <!--<i class="arrow-sort" />-->
                      </span>
                    </td>
                    <td class="hr-wrap-holder">
                      <span class="heading-label pr">{{
                        label.get("pay_rate")
                      }}</span>
                    </td>
                    <td class="lt-wrap-holder">
                      <span class="heading-label lt">{{
                        label.get("location")
                      }}</span>
                    </td>
                    <td class="ovt-wrap-holder">
                      <span class="heading-label ovt">{{
                        label.get("overtime")
                      }}</span>
                    </td>
                    <td width="82px"></td>
                  </tr>
                </thead>
                <tbody>
                  <tr class="search-bar-row">
                    <th>
                      <form class="search-bar" action="javascript:void(0);">
                        <button type="submit" class="search-loop">
                          <i class="atto atto-search-loop" />
                        </button>
                        <input
                          v-model="search"
                          type="search"
                          :placeholder="label.get('search')"
                        />
                      </form>
                    </th>
                  </tr>
                  <tr v-for="(item, idx) in filteredMembers" :key="idx">
                    <router-link
                      class="profile-link"
                      :to="{
                        name: 'MemberProfileComponent',
                        params: { uid: item.uid },
                      }"
                      v-if="item.type !== undefined && item.type === 'member'"
                    >
                      <th>
                        <div class="pic-wrap">
                          <span v-if="!item.avatar" class="initials"
                            >{{ item.initials }}
                          </span>
                          <img
                            v-if="item.avatar"
                            :src="item.avatar"
                            width="40"
                            height="40"
                            class="member-pic"
                          />
                        </div>
                        <div class="member-wrap">
                          <h4 class="member-name">
                            {{ item.name }}
                            <span
                              v-if="item.quickbooks_user"
                              v-b-tooltip.hover
                              class="qb-icon"
                              title="Linked in Quickbooks"
                            />
                            <span
                              v-if="item.xero_employee"
                              v-b-tooltip.hover
                              class="xero-icon"
                              title="Linked in Xero"
                            />
                          </h4>
                        </div>
                      </th>
                      <td class="role-wrap-holder">
                        <div class="role-wrap">
                          <span class="detailed-label">{{
                            getRoleLabel(item)
                          }}</span>
                        </div>
                      </td>
                      <td class="dep-wrap-holder">
                        <div class="dep-wrap">
                          <span
                            v-if="departmentEnabled && item.department"
                            class="detailed-label"
                          >
                            {{ item.department.name }}
                          </span>
                          <span
                            v-if="!departmentEnabled"
                            class="detailed-label"
                          >
                            N/A
                          </span>
                          <span
                            v-if="departmentEnabled && !item.department"
                            class="detailed-label"
                          >
                            {{ label.get("no_department") }}
                          </span>
                        </div>
                      </td>
                      <td class="hr-wrap-holder">
                        <div class="hr-wrap">
                          <span class="detailed-label">{{
                            item.pay_rate_hours
                          }}</span>
                        </div>
                      </td>
                      <td class="lt-wrap-holder">
                        <div class="lt-wrap">
                          <span
                            class="detailed-label"
                            v-bind:class="{
                              on: item.user_settings.location_tracking_enabled,
                              off: !item.user_settings
                                .location_tracking_enabled,
                            }"
                          >
                            {{
                              item.user_settings.location_tracking_enabled
                                ? label.get("on")
                                : label.get("off")
                            }}
                          </span>
                        </div>
                      </td>
                      <td class="ovt-wrap-holder">
                        <div class="ovt-wrap">
                          <span class="detailed-label">{{
                            getOvertimeHours(item.user_settings)
                          }}</span>
                        </div>
                      </td>
                      <td class="buttons">
                        <div class="member-options">
                          <button
                            v-if="canDeleteMember(item)"
                            class="delete-member"
                            @click="deleteMember($event, item)"
                          >
                            <i class="atto atto-delete" />
                          </button>
                          <span
                            v-if="
                              !canDeleteMember(item) &&
                                item.id !== ownerId &&
                                item.id !== user.id
                            "
                            v-b-tooltip="{
                              title: label.get(
                                'manage_team_dont_have_permission'
                              ),
                              placement: 'bottomleft',
                              trigger: 'hover',
                              customClass: 'alert-wrapper',
                            }"
                          >
                            <button class="delete-member" :disabled="true">
                              <i class="atto atto-delete" />
                            </button>
                          </span>
                          <div class="arrow">
                            <i class="atto atto-r-arrow-b"></i>
                          </div>
                        </div>
                      </td>
                    </router-link>

                    <router-link
                      class="profile-link"
                      :to="{
                        name: 'InviteProfileComponent',
                        params: { id: item.id },
                      }"
                      v-if="item.type !== undefined && item.type === 'invite'"
                    >
                      <th>
                        <div class="pic-wrap">
                          <i class="atto atto-avatar" />
                          <span class="initials" />
                          <img src="" alt="" class="member-pic" />
                        </div>
                        <div class="member-wrap">
                          <h4 class="member-name">
                            {{ item.email }}
                          </h4>
                        </div>
                      </th>
                      <td class="role-wrap-holder">
                        <div class="role-wrap">
                          <span class="detailed-label">{{
                            getInviteRoleLabel(item)
                          }}</span>
                        </div>
                      </td>
                      <td class="dep-wrap-holder">
                        <div class="dep-wrap">
                          <span class="detailed-label">-</span>
                        </div>
                      </td>
                      <td class="hr-wrap-holder">
                        <div class="hr-wrap">
                          <span class="detailed-label">-</span>
                        </div>
                      </td>
                      <td class="lt-wrap-holder">
                        <div class="lt-wrap">
                          <span class="detailed-label none">-</span>
                        </div>
                      </td>
                      <td class="ovt-wrap-holder">
                        <div class="ovt-wrap">
                          <span class="detailed-label">-</span>
                        </div>
                      </td>
                      <td class="buttons">
                        <div class="member-options">
                          <button
                            class="delete-member"
                            @click="deleteInvite($event, item)"
                          >
                            <i class="atto atto-delete" />
                          </button>
                          <router-link
                            class="arrow"
                            :to="{
                              name: 'InviteProfileComponent',
                              params: { id: item.id },
                            }"
                            v-if="
                              item.type !== undefined && item.type === 'invite'
                            "
                          >
                            <i class="atto atto-r-arrow-b"></i>
                          </router-link>
                        </div>
                      </td>
                    </router-link>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <delete-member-component
        v-if="deleteItem"
        :id="itemId"
        :type="itemType"
      />
    </div>
  </div>
</template>

<script>
import EditMemberModalComponent from "../components/EditMemberModalComponent";
import DeleteMemberComponent from "../components/DeleteMemberComponent";
import MemberService from "../services/MemberService";
export default {
  name: "AllManageTeamComponent",
  components: {
    EditMemberModalComponent,
    DeleteMemberComponent,
  },
  data() {
    return {
      user: this.$store.state.user,
      ownerId: this.$store.state.company.user_id,
      members: this.$store.state.members,
      invites: this.$store.state.invites,
      departmentEnabled: this.$store.state.companySettings.enable_departments,
      showEditMember: false,
      selectedMember: null,
      deleteItem: false,
      itemId: null,
      itemType: null,
      search: "",
    };
  },
  created() {
    if (!this.$store.state.permission.canAccessManageTeam) {
      this.$router.push({ path: "/settings/profile" });
      return false;
    }
    this.getMembers();
  },
  computed: {
    filteredMembers() {
      const items = [
        ...this.members.map((item) => {
          item.type = "member";
          return item;
        }),
        ...this.invites.map((item) => {
          item.type = "invite";
          return item;
        }),
      ];

      console.log(items);
      //return items;
      return items.filter((item) => {
        if (item.type === "member") {
          return (
            item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        } else {
          return (
            item.email.toLowerCase().indexOf(this.search.toLowerCase()) > -1
          );
        }
      });
    },
  },
  mounted() {
    this.$root.$on("hideDeleteMember", this.hideDeleteMember);
    this.$root.$on("hideEditMember", this.hideEditMember);
    this.$root.$on("reloadInvites", this.reloadInvites);
  },
  beforeDestroy() {
    this.$root.$off("hideDeleteMember");
    this.$root.$off("hideEditMember");
    this.$root.$off("reloadInvites");
  },
  methods: {
    getMembers() {
      this.$store.commit("showLoading");
      MemberService.getMembersWithSettings()
        .then((result) => {
          this.members = result.members;
          this.invites = result.invites;
          this.$store.commit("hideLoading");
        })
        .catch((error) => {
          this.$store.commit("hideLoading");
        });
    },
    getRoleLabel(member) {
      if (member.id === this.ownerId) {
        return this.label.get("owner");
      }
      if (member.role_id === 1) {
        return this.label.get("admin");
      }
      if (member.role_id === 2) {
        return this.label.get("manager");
      }
      if (member.role_id === 3) {
        return this.label.get("employee");
      }
      return this.label.get("employee");
    },
    getInviteRoleLabel(invite) {
      if (invite.role === 1) {
        return this.label.get("admin");
      }
      if (invite.role === 2) {
        return this.label.get("manager");
      }
      if (invite.role === 3) {
        return this.label.get("employee");
      }
      return this.label.get("employee");
    },
    getInviteStatus(invite) {
      if (invite.paid) {
        return this.label.get("request_pending");
      }
      return this.label.get("pending_payment");
    },
    getOvertimeHours(memberSetting) {
      let hours = "";
      if (memberSetting.weekly_overtime) {
        const hourAndMinutes = memberSetting.weekly_calculate_after.split(":");
        if (hourAndMinutes[1] === "00") {
          hours = hourAndMinutes[0] + "h " + this.label.get("weekly");
        } else {
          hours =
            hourAndMinutes[0] +
            "h " +
            hourAndMinutes[1] +
            "m " +
            this.label.get("weekly");
        }
      }

      if (memberSetting.daily_overtime) {
        const hourAndMinutes = memberSetting.daily_calculate_after.split(":");
        if (hours.length > 0) {
          hours += " · ";
        }

        if (hourAndMinutes[1] === "00") {
          hours += hourAndMinutes[0] + "h " + this.label.get("daily");
        } else {
          hours +=
            hourAndMinutes[0] +
            "h " +
            hourAndMinutes[1] +
            "m " +
            this.label.get("daily");
        }
      }

      if (memberSetting.daily_double_overtime) {
        const hourAndMinutes = memberSetting.daily_double_calculate_after.split(
          ":"
        );
        if (hours.length > 0) {
          hours += " · ";
        }
        if (hourAndMinutes[1] === "00") {
          hours += hourAndMinutes[0] + "h " + this.label.get("daily_double");
        } else {
          hours +=
            hourAndMinutes[0] +
            "h " +
            hourAndMinutes[1] +
            "m " +
            this.label.get("daily_double");
        }
      }

      if (hours.length === 0) {
        return this.label.get("overtime_no_overtime");
      }

      return hours;
    },
    canEditMember(member) {
      if (this.user.id === this.ownerId) {
        return true;
      }
      return this.user.role_id < member.role_id;
    },
    canDeleteMember(member) {
      if (this.user.id === this.ownerId && member.id !== this.user.id) {
        return true;
      }
      if (member.id === this.ownerId || member.id === this.user.id) {
        return false;
      }
      return this.user.role_id < member.role_id;
    },
    inviteMember() {
      this.$root.$emit("showInviteMembers");
    },
    editMember(member) {
      if (!this.canEditMember(member)) {
        return false;
      }
      this.selectedMember = member;
      this.showEditMember = true;
    },
    hideEditMember() {
      this.showEditMember = false;
      this.selectedMember = null;
    },
    deleteMember(e, member) {
      e.preventDefault();
      e.stopPropagation();
      this.itemType = "member";
      this.itemId = member.id;
      this.deleteItem = true;
    },
    deleteInvite(e, invite) {
      e.preventDefault();
      e.stopPropagation();
      this.itemType = "invite";
      this.itemId = invite.id;
      this.deleteItem = true;
    },

    hideDeleteMember(data) {
      if (data) {
        if (data.type === "member") {
          const member = this.members.find((item) => {
            return item.id === data.id;
          });
          if (member) {
            const index = this.members.indexOf(member);
            this.members.splice(index, 1);
            this.$store.commit("members", this.members);
          }
        }
        if (data.type === "invite") {
          const invite = this.invites.find((item) => {
            return item.id === data.id;
          });
          if (invite) {
            const index = this.invites.indexOf(invite);
            this.invites.splice(index, 1);
            this.$store.commit("invites", this.invites);
          }
        }
      }

      this.deleteItem = false;
      this.itemId = null;
      this.itemType = null;
    },
    reloadInvites() {
      this.getMembers();
    },
  },
};
</script>

<style lang="scss" scoped>
.heading {
  display: flex;
  flex-direction: row;
  padding: 28px 80px 29px;
  border-bottom: 0;

  button.invite {
    margin-left: auto;
    padding: 0;
    font-family: "Roboto", sans-serif;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-weight: 500;
    color: #00b9cb;
    display: flex;
    flex-direction: row;
    align-items: center;
    @include base-transition(ease all 0.15s);

    i {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 8px;
      font-size: 16px;
      @include base-transition(ease all 0.15s);
    }

    &:hover {
      color: #06a5a4;

      i {
        color: #06a5a4;
      }
    }
  }
}

.list-container {
  width: 100%;
  min-width: 940px;

  .table-heading {
    padding: 12px 64px;
    background: #fafafa;
    border-bottom: 1px solid #efefef !important;
    display: flex;
    flex-direction: row;
    height: 35px;

    span.heading-label {
      display: inline-flex;
      color: #999999;
      font: $roboto-medium 0.625rem/0.6875rem $roboto-font;
      text-transform: uppercase;
      letter-spacing: 0.5px;

      i.arrow-sort {
        margin-left: 6px;
      }

      &.name {
        /*min-width: 200px;
        width: 20%;*/
        width: 300px;
      }
      &.dep {
        min-width: 135px;
        width: 15%;
      }
      &.rl {
        min-width: 105px;
        width: 10%;
      }
      &.ovt {
        min-width: 246px;
        width: 25%;
      }
      &.hr {
        width: 48px;
      }
      &.lt {
        min-width: 90px;
        width: 6%;
      }
      &.pr {
        min-width: 100px;
        width: 10%;
      }
    }
  }

  .team-members {
    li {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0;
      height: 50px;
      border-top: 1px solid $atto-light-grey;
      border-bottom: none;

      a {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 7px 8px 7px 16px;
        height: 50px;

        .pic-wrap {
          width: 36px;
          height: 36px;
          border-radius: 100%;
          margin-right: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          align-content: center;

          i.atto-avatar {
            font-size: 2.25rem;
            margin: 0;
            width: auto;
          }

          span.initials {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 0.875rem;
            line-height: 1.5rem;
            font-weight: 400;
            font-family: "Roboto", sans-serif;
            color: #999;
            background-color: #efefef;
            border-radius: 100%;
            width: 36px;
            height: 36px;
            text-transform: uppercase;
          }

          img {
            border-radius: 100%;
          }
        }

        .member-wrap {
          min-width: 200px;
          width: 19.2%;
          margin: 0;
          display: inline-flex;
          flex-direction: column;
          align-items: flex-start;

          .member-name {
            color: #262626;
            font: $roboto-regular 1rem/1.25rem $roboto-font;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            display: inline-block;
            align-items: center;
            /*max-width: 140px;*/

            .qb-icon {
              width: 16px;
              height: 16px;
              margin-left: 4px;
              background-image: url("~@assets/images/quickbooks-icon.svg");
              background-size: 16px;
              background-repeat: no-repeat;
              background-position: center;
              display: inline-flex;
            }

            .xero-icon {
              width: 20px;
              height: 20px;
              margin-left: 4px;
              background-image: url("~@assets/images/xero-icon.svg");
              background-size: 16px;
              background-repeat: no-repeat;
              background-position: center;
              display: inline-flex;
            }
          }

          .email {
            display: inline-flex;
            color: #999;
            font-family: "Roboto", sans-serif;
            font-size: 0.75rem;
            font-weight: 400;
            line-height: 1.5rem;
            margin-top: -4px;
          }
        }

        > div {
          display: inline-flex;
          align-items: center;
          > .detailed-label {
            font: $roboto-regular 0.875rem/1rem $roboto-font;
            color: #262626;
            display: inline-flex;
          }
        }

        .dep-wrap {
          min-width: 135px;
          width: 14.5%;
          margin: 0;
        }
        .role-wrap {
          /* min-width: 137px;*/
          min-width: 105px;
          width: 10%;
          margin: 0;
        }
        .ovt-wrap {
          width: 114px;
          margin-right: 16px;
        }
        .hr-wrap {
          min-width: 100px;
          width: 9.5%;
          margin: 0;
        }
        .lt-wrap {
          min-width: 90px;
          width: 6%;
          margin: 0;

          span {
            width: 51px;
            height: 25px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 1px solid #e3e3e3;
            border-radius: 12px;
            background-color: $atto-grey;
            text-transform: uppercase;
            font: $roboto-regular 0.75rem/1.5rem $roboto-font;

            &.on {
              color: $atto-font-color;
            }
            &.off {
              color: $atto-red;
            }
            &.none {
              border-radius: 0;
              border: none;
              background-color: transparent;
            }
          }
        }
        .ovt-wrap {
          /* min-width: 246px;*/
          min-width: 140px;
          width: 20%;
          margin: 0;
        }

        > div {
          .atto-select {
            .select-heading {
              span {
                min-width: calc(100% - 24px);
                max-width: calc(100% - 24px);
              }
            }
          }
        }

        &:hover {
          background-color: $atto-grey;
          .member-options {
            opacity: 1;
            background-color: $atto-grey;

            .arrow {
              display: flex;
              width: 40px;
              height: 40px;
              align-items: center;
              justify-content: center;
              text-align: center;
              background-color: transparent;
              border: 0;
              padding: 0;
              position: relative;
              margin-left: auto;

              i {
                font-size: 16px;
                text-align: center;
                align-items: center;
                justify-content: center;
                color: $atto-dark-grey;
                border-radius: 100%;
                margin: 0;
              }

              &:hover:not(:disabled) {
                cursor: pointer;
                background-color: $atto-light-grey;
                border-radius: 50%;
                i {
                  &::before {
                    color: $atto-font-color;
                  }
                }
              }
              &:hover {
                cursor: pointer !important;
              }
            }
            .delete-member {
              opacity: 1;
            }
          }
        }
      }
      .member-options {
        display: inline-flex;
        align-items: center;
        flex-direction: row;
        opacity: 1;
        position: relative;
        right: 8px;

        .edit-member,
        .delete-member {
          display: flex;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-color: transparent;
          border: 0;
          padding: 0;
          position: relative;

          i {
            position: absolute;
            display: inline-flex;
            width: 40px;
            height: 40px;
            font-size: 18px;
            text-align: center;
            align-items: center;
            justify-content: center;
            color: $atto-dark-grey;
            border-radius: 100%;
          }

          &:hover:not(:disabled) {
            cursor: pointer;
            i {
              background-color: $atto-light-grey;
              &::before {
                color: $atto-font-color;
              }
            }
          }

          &:disabled {
            cursor: not-allowed;
          }
        }

        .delete-member {
          opacity: 0;
        }
      }

      &:hover {
        .member-options {
          opacity: 1;
          background-color: $atto-grey;

          .arrow {
            display: flex;
            width: 40px;
            height: 40px;
            align-items: center;
            justify-content: center;
            text-align: center;
            background-color: transparent;
            border: 0;
            padding: 0;
            position: relative;
            margin-left: auto;

            i {
              font-size: 16px;
              text-align: center;
              align-items: center;
              justify-content: center;
              color: $atto-dark-grey;
              border-radius: 100%;
              margin: 0;
            }

            &:hover:not(:disabled) {
              cursor: pointer;
              background-color: $atto-light-grey;
              border-radius: 50%;
              i {
                &::before {
                  color: $atto-font-color;
                }
              }
            }

            &:hover {
              cursor: pointer !important;
            }
          }
          .delete-member {
            opacity: 1;
          }
        }
      }
    }

    &.members-other-info {
      overflow-x: auto;
      min-width: 1260px;
      overflow-y: hidden;
      width: 100%;
    }
  }
}
.white-card
  .list-container
  ul
  li#members-other-info:hover:hover
  + ul
  li#profile-info {
  background-color: #fafafa !important;
}
.search-bar {
  height: 50px;
  width: 100%;
  padding: 13px 22px;
  display: flex;
  align-items: center;

  .search-loop {
    height: 24px;
    display: flex;
    align-items: center;
    .atto-search-loop {
      font-size: 0.75rem;
      color: $background;
    }
  }

  input {
    border: none;
    font: $roboto-regular 0.75rem/1.5rem $roboto-font;
    color: $atto-font-color;
    width: calc(100% - 60px);
    height: 24px;
    margin-left: 14px;

    &::-webkit-input-placeholder {
      color: $atto-not-active;
    }
  }
}
.pic-wrap {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;

  i.atto-avatar {
    font-size: 2.25rem;
    margin: 0;
    width: auto;
  }

  span.initials {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-weight: 400;
    font-family: "Roboto", sans-serif;
    color: #999;
    background-color: #efefef;
    border-radius: 100%;
    width: 36px;
    height: 36px;
    text-transform: uppercase;
  }

  img {
    border-radius: 100%;
  }
}
.member-wrap {
  min-width: 200px;
  width: 19.2%;
  margin: 0;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;

  .member-name {
    color: #262626;
    font: $roboto-regular 1rem/1.25rem $roboto-font;
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    display: inline-block;
    align-items: center;
    /*max-width: 140px;*/

    .qb-icon {
      width: 16px;
      height: 16px;
      margin-left: 4px;
      background-image: url("~@assets/images/quickbooks-icon.svg");
      background-size: 16px;
      background-repeat: no-repeat;
      background-position: center;
      display: inline-flex;
    }

    .xero-icon {
      width: 20px;
      height: 20px;
      margin-left: 4px;
      background-image: url("~@assets/images/xero-icon.svg");
      background-size: 16px;
      background-repeat: no-repeat;
      background-position: center;
      display: inline-flex;
    }
  }

  .email {
    display: inline-flex;
    color: #999;
    font-family: "Roboto", sans-serif;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.5rem;
    margin-top: -4px;
  }
}

tbody {
  width: 100%;
  tr {
    width: 100%;
    height: 50px;
    &:hover {
      background-color: $atto-grey;

      th {
        background-color: $atto-grey;
      }
      td {
        background-color: $atto-grey;
        &.buttons {
          .member-options {
            .delete-member {
              opacity: 1;
            }
          }
        }
      }
    }
    &.search-bar-row {
      width: 100%;
      height: 50px;
      &:hover {
        background-color: transparent;

        th {
          background-color: transparent;
        }
      }
      th {
        padding-left: 0;
        width: 100%;
        border-top: none;
      }
    }
    .detailed-label {
      font: $roboto-regular 0.875rem/1rem $roboto-font;
      color: #262626;
      display: inline-flex;
    }
  }
  th {
    height: 50px;
    padding-left: 16px;
  }
  td {
    height: 50px;
    &.buttons {
      width: 82px;
      display: flex;
      justify-content: flex-end;
      .member-options {
        display: inline-flex;
        align-items: center;
        flex-direction: row;
        opacity: 1;
        position: relative;
        right: 8px;

        .arrow {
          display: flex;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-color: transparent;
          border: 0;
          padding: 0;
          position: relative;
          margin-left: auto;

          i {
            font-size: 16px;
            text-align: center;
            align-items: center;
            justify-content: center;
            color: $atto-dark-grey;
            border-radius: 100%;
            margin: 0;
          }

          &:hover:not(:disabled) {
            cursor: pointer;
            background-color: $atto-light-grey;
            border-radius: 50%;
            i {
              &::before {
                color: $atto-font-color;
              }
            }
          }

          &:hover {
            cursor: pointer !important;
          }
        }
        .edit-member,
        .delete-member {
          display: flex;
          width: 40px;
          height: 40px;
          align-items: center;
          justify-content: center;
          text-align: center;
          background-color: transparent;
          border: 0;
          padding: 0;
          position: relative;

          i {
            position: absolute;
            display: inline-flex;
            width: 40px;
            height: 40px;
            font-size: 18px;
            text-align: center;
            align-items: center;
            justify-content: center;
            color: $atto-dark-grey;
            border-radius: 100%;
          }

          &:hover:not(:disabled) {
            cursor: pointer;
            i {
              background-color: $atto-light-grey;
              &::before {
                color: $atto-font-color;
              }
            }
          }

          &:disabled {
            cursor: not-allowed;
          }
        }
        .delete-member {
          opacity: 0;
        }
      }
    }
    .lt-wrap {
      .detailed-label {
        width: 51px;
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid #e3e3e3;
        border-radius: 12px;
        background-color: $atto-grey;
        text-transform: uppercase;
        font: $roboto-regular 0.75rem/1.5rem $roboto-font;

        &.on {
          color: $atto-font-color;
        }
        &.off {
          color: $atto-red;
        }
        &.none {
          border-radius: 0;
          border: none;
          background-color: transparent;
        }
      }
    }
  }
}
.role-wrap-holder {
  width: 15%;
}
.dep-wrap-holder {
  width: 20%;
  max-width: 211px;
}
.hr-wrap-holder {
  width: 15%;
  max-width: 158px;
}
.lt-wrap-holder {
  width: 10%;
  max-width: 105px;
}
.ovt-wrap-holder {
  width: 40%;
}
table.list-container {
  table-layout: fixed;
  width: 100%;
  *margin-left: -100px; /*ie7*/
  border-spacing: 0;

  .table-heading {
    height: 35px;
    padding: 5px 0 6px 0 !important;
    background: $atto-grey;
    display: flex;
    align-items: center;
    tr {
      width: 100%;
      height: 35px;
      display: flex;
      align-items: center;

      th {
        height: 35px;
        padding-left: 64px;
        background: $atto-grey;
        border-top: none;
        display: flex;
        align-items: center;
        top: 0;
        border-bottom: 1px solid $atto-light-grey;
      }
      td {
        height: 35px;
        border-bottom: none;
      }
    }
  }
}
td,
th {
  vertical-align: center;
  border-top: 1px solid $atto-light-grey;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;

  &:last-child {
    border-bottom: none;
  }
}
th {
  position: absolute;
  *position: relative; /*ie7*/
  left: 0;
  width: 300px;
}

.outer {
  position: relative;
}
.inner {
  overflow-x: auto;
  overflow-y: visible;
  width: calc(100% - 300px);
  margin-left: 300px;
}

.profile-link {
  width: 100%;
  display: flex;
}
.test {
  width: 250px;
}
.dep-wrap {
  min-width: 135px;

  margin: 0;
}
.role-wrap {
  /* min-width: 137px;*/
  min-width: 105px;

  margin: 0;
}
.ovt-wrap {
  width: 100%;
  margin-right: 16px;
}
.hr-wrap {
  min-width: 100px;
  margin: 0;
}
.lt-wrap {
  min-width: 90px;

  margin: 0;

  span {
    width: 51px;
    height: 25px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e3e3e3;
    border-radius: 12px;
    background-color: $atto-grey;
    text-transform: uppercase;
    font: $roboto-regular 0.75rem/1.5rem $roboto-font;

    &.on {
      color: $atto-font-color;
    }
    &.off {
      color: $atto-red;
    }
    &.none {
      border-radius: 0;
      border: none;
      background-color: transparent;
    }
  }
}
.ovt-wrap {
  min-width: 246px;
  margin: 0;
}

@media (max-width: 1315px) {
  .list-container {
    min-width: 650px;
  }
  table.list-container {
    min-width: 940px;
  }
}
@media (max-width: 1080px) {
  th {
    width: 300px;
  }
  .list-container {
    min-width: 400px;
  }
  /* .inner {
    overflow-x:auto;
    overflow-y:visible;
    width: calc(100% - 300px);
    margin-left: 300px;
  }*/
}
</style>

<style lang="scss">
.members-card .ps__rail-x {
  opacity: 1;
}

@media (max-width: 1315px) {
  .overtime-preferences {
    .card-content {
      p {
        width: 75% !important;
      }
    }
  }
  .card-content.remove-member p {
    width: 70% !important;
  }
}
@media (max-width: 1265px) {
  .white-card {
    .user-details {
      flex-flow: column !important;

      .role-and-department {
        max-width: 410px;
        margin-top: 65px;
      }
    }
  }
}
</style>
